'use strict'

var angular = require('angular')
var Raven = require('raven-js')

module.exports = angular.module('ngRaven', [])
  .config(registerDecorator)
  .name

registerDecorator.$inject = ['$provide']
function registerDecorator ($provide) {
  $provide.decorator('$exceptionHandler', decorateExceptionHandler)
}

decorateExceptionHandler.$inject = ['$delegate']
function decorateExceptionHandler ($exceptionHandler) {
  return function angularExceptionHandler (err, cause) {
    $exceptionHandler(err, cause)
    Raven.captureException(err, {extra: {cause: cause}})
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/ng-raven/index.js
// module id = 286
// module chunks = 1